<template>
  <rpm-input
    type="date"
    v-model="form.start_date"
    label="Data de início"
    required
    class="col-span-3"
    :errors="errors.start_date"
  />
  <rpm-input 
    type="date" 
    v-model="form.end_date" 
    label="Fim do período"
    class="col-span-3"
    :errors="errors.end_date"
  />
  <rpm-input 
    type="select" 
    v-model="form.collaborator_function_id" 
    label="Função" 
    required
    class="col-span-3" 
    :options="collaboratorFunctions" 
    optionLabel="name" 
    optionValue="id"
    :errors="errors.collaborator_function_id"
  />
  <rpm-input 
    type="select" 
    v-model="form.organization_id" 
    label="Organizações" 
    required
    class="col-span-3" 
    :options="organizations" 
    optionLabel="name" 
    optionValue="id"
    :errors="errors.organization_id"
  />
  <rpm-input 
    type="text" 
    v-model="form.registration_id" 
    label="Matrícula" 
    required
    class="col-span-3"
    :errors="errors.registration_id"
  />
</template>

<script>
import {reactive, toRef, onMounted, ref} from "vue";
import collaboratorFunctionRepository from '#repositories/collaboratorFunctionRepository.js'
import organizationsRepository from '#repositories/organizationsRepository.js'
import moment from "moment/moment";


export default {
  name: 'CollaborationForm',
  props: {
    collaboration: {
      type: Object
    },
    errors:{
      type: Object
    }
  },
  setup(props) {
    const form = reactive(toRef(props, 'collaboration'))
    const collaboratorFunctions = ref([])
    const organizations = ref([])

    function getCollaboratorFunctions() {
      collaboratorFunctionRepository.getCollaboratorFunctions().then((response) => {
        collaboratorFunctions.value = response.data
      })
    }
    function getOrganizations() {
      organizationsRepository.getOrganizations().then((response) => {
        organizations.value = response.data
      })
    }

    function currentDate(){
      return moment(new Date()).format('YYYY-MM-DD')
    }

    onMounted(() => {
      getCollaboratorFunctions()
      getOrganizations()
      form.value.start_date = currentDate()
    })
    return {
      form,
      organizations,
      collaboratorFunctions
    }
  }

}
</script>